<template>
  <div class="layout">
    <div class="overlay" v-if="loading"></div>
    <div style="z-index: 105 !important">
      <SideNavbar @button-click="langchange"></SideNavbar>
    </div>
    <div class="regdevice_contents">
      <BackButton @click="goBack" :message="this.lang.back_button"></BackButton>
      <div class="regdevice_header">
        {{ this.lang.title }}
      </div>
      <div class="dashboard_role">Current Role : {{ this.currentRole }}</div>
      <div class="regdevice_secondary_container">
        <p class="regdevice_secondary_header">{{ this.lang.second_title }}</p>
        <p class="contents_header_text">{{ this.lang.content }}</p>
      </div>
      <div class="customercat-container" v-if="isEnterpriseAvailable === true">
        <div
          class="form-selection-type"
          style="margin-bottom: 5px; justify-items: center"
        >
          <label class="categoryopt-label" for="fullname">{{
            this.lang.company_selection
          }}</label>
        </div>
      </div>
      <div class="regdevice_container">
        <div v-if="register_option == '1'">
          <form class="col-md-6 d-flex flex-column w-100" @submit.prevent="register">
            <div class="d-flex flex-row">
              <div class="mx-3">
                <div class="form-group" style="margin-bottom: 5px">
                  <label class="input_header_style" for="fullname">{{
                    this.lang.fullname
                  }}</label>
                  <input
                    type="text"
                    class="form-control custom_input_form"
                    id="fullname"
                    :placeholder="this.lang.fullname_hint"
                    v-model="fullname"
                    required
                  />
                </div>
                <div class="form-group" style="margin-bottom: 5px">
                  <label class="input_header_style" for="msisdn">{{
                    this.lang.msisdn
                  }}</label>
                  <input
                    @focus="addPhoneCode"
                    type="tel"
                    class="form-control custom_input_form"
                    id="msisdn"
                    :placeholder="this.id_info_collect.preset_contact_hint"
                    v-model="msisdn"
                    required
                    pattern="[0-9]{9,18}"
                    title="Please input your MSISDN number ranging from 11-18 digits only" 
                  />
                </div>
                <div class="form-group" style="margin-bottom: 5px">
                  <label class="input_header_style" for="serialnum">{{
                    this.lang.serialnum
                  }}</label>
                   <input
                    v-model="search_filtered_serial_number"
                    :placeholder="this.lang.serialnum_search"
                    class="form-control custom_input_form"
                    
                  />
                  <select
                    type="text"
                    class="form-control custom_input_form"
                    id="serialnum"
                    @change="checkIfSerialNumberSelected"
                    placeholder="Select serial number"
                    v-model="serialnum"
                    required
                    pattern="[A-Z0-9]{8,14}" 
                    title="Please input a valid serial number" 
                  >
                  <option>-Select device-</option>
                  <option v-for="(item, index) in filtered_device_selection_list"
        :key="index+1"
        :value="item[2]">{{item[0]}}-{{item[2]}}-{{item[1]}}</option>
                </select>
                </div>
                
              </div>

              <div class="mx-3">
                <div class="form-group" style="margin-bottom: 5px">
                  <label class="input_header_style" for="nric">{{
                    this.id_info_collect.preset_reg_title
                  }}</label>
                  <input
                    type="text"
                    class="form-control custom_input_form"
                    id="nric"
                    :placeholder="this.id_info_collect.preset_reg_hint"
                    v-model="nric"
                    required
                    pattern="^[0-9]{12}$|^[A-Za-z0-9]+$" 
                    :title="this.id_info_collect.preset_reg_err"
                  />
                </div>
                <div class="form-group" style="margin-bottom: 5px">
                  <label class="input_header_style" for="email">{{
                    this.lang.email
                  }}</label>
                  <input
                    type="email"
                    class="form-control custom_input_form"
                    id="email"
                    :placeholder="this.lang.email_hint"
                    v-model="email"
                    required
                  />
                </div>
                <div class="form-group" style="margin-bottom: 5px">
                  <label class="input_header_style" for="contracttenure">{{
                    this.lang.contracttenure
                  }}</label>
                  <input
                    type="tel"
                    class="form-control custom_input_form"
                    id="contracttenure"
                    :placeholder="this.lang.contracttennue_hint"
                    v-model="contracttenure"
                    required
                    pattern="[0-9]{1,2}"
                    title="Please input a valid amount for contract tenure (months)"
                  />
                </div>
              </div>
            </div>

            <div class="text-center button_container d-flex justify-content-center" style="margin-top: -10px;">
              <button type="submit" class="reg_btn" data-testid="register-button1" :disabled="allow_register">
                {{ this.lang.register_button }}
              </button>
              <div v-if="tryagainWarning" class="warning-msg text-center">
                {{ this.lang.tryagain }}
              </div>
            </div>
          </form>
        </div>
      </div>

      <div class="loading-card" v-if="success">
        <div class="loading-content">
          <div class="loading-text">
            <p class="notiftext_title">{{ this.lang.notice_title }}</p>
            <p class="notiftext">{{ this.lang.notice_text }}</p>
            <img src="../../assets/check.png" class="img_style" />
            <div style="margin-top: 5px">
              <button
                style="margin-left: 10px"
                type="submit"
                class="dashboard_btn text-center"
                data-testid="dashboard-button"
                @click="goDashboard"
              >
                {{ this.lang.notice_button2 }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="loading-card" v-if="tryagainWarning">
        <div class="loading-content">
          <div class="loading-text">
            <p class="notiftext_title">{{ this.lang.error_prompt_title }}</p>
            <p class="notiftext">{{ this.lang.error_prompt_description }}</p>
            <img src="../../assets/multiply.png" class="img_style" />
            <div style="margin-top: 5px">
              <button
                style="margin-left: 10px"
                type="submit"
                class="dashboard_btn text-center"
                @click="backToRegister"
              >
                {{ this.lang.error_prompt_button1 }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <!--Temporary prompt to load the csv-->
      <div class="loading-card" v-if="loadingCommand">
        <div class="loading-content">
          <div class="loading-text">
            <img src="../../assets/loading.gif" class="img_style" />
            <p class="notiftext_title">Loading CSV File...</p>
          </div>
        </div>
      </div>
      <div
        class="loading-card"
        v-if="tryagainWarning2 && productFamily != null"
      >
        <div class="loading-content">
          <div class="loading-text">
            <div v-if="productFamily == 'Mac'">
              <p class="notiftext_title">
                {{ this.lang.feature_unavailable_macos[0] }}
              </p>
              <p class="notiftext">{{ this.lang.register_api_error_msg }}</p>
              <img src="../../assets/multiply.png" class="img_style" />
              <div style="margin-top: 5px">
                <button
                  style="margin-left: 10px"
                  type="submit"
                  class="dashboard_btn text-center"
                  @click="backToRegister"
                >
                  {{ this.lang.feature_unavailable_macos[2] }}
                </button>
              </div>
            </div>
            <div v-if="productFamily == 'iPad'">
              <p class="notiftext_title">
                {{ this.lang.feature_unavailable_ipados[0] }}
              </p>
              <p class="notiftext">{{ this.lang.register_api_error_msg }}</p>
              <img src="../../assets/multiply.png" class="img_style" />
              <div style="margin-top: 5px">
                <button
                  style="margin-left: 10px"
                  type="submit"
                  class="dashboard_btn text-center"
                  @click="backToRegister"
                >
                  {{ this.lang.feature_unavailable_ipados[2] }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--Access denied-->
      <div class="loading-card" v-if="page_unavailable">
        <div class="loading-content">
          <div class="loading-text">
            <img src="../../assets/multiply.png" class="img_style_denied_perms" />
            <p class="notiftext_title_denied_perms">
              {{ this.lang.popup_card_access_denied[0] }}
            </p>
            <p class="notiftext_denied_perms">
              {{ this.lang.popup_card_access_denied[1] }}
            </p>
            <button
              type="submit"
              class="mandev_btn text-center"
              style="margin-top: 20px"
              @click="goBack"
            >
              {{ this.lang.popup_card_access_denied[2] }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <BottomFooter ref="BottomFooterRef"></BottomFooter>
</template>

<script>
import SideNavbar from "./../SideNavbar.vue";
import BackButton from "./../BackButton.vue";
import BottomFooter from "./../BottomFooter.vue";
import { useDebounceFn } from '@vueuse/core';

export default {
  components: {
    SideNavbar,
    BackButton,
    BottomFooter,
  },
  data() {
    return {
      inputValue: '',
      isLoading: false,
      debouncedTryHit: null, 
      is_not_phone: "0",
      page_unavailable: false,
      fullname: "",
      serialnum: "-Select device-",
      msisdn: "",
      device_selection_list: [],
      search_filtered_serial_number: "",
      email: "",
      nric: "",
      imei1: "",
      imei2: "",
      contracttenure: "",
      register_option: "1",
      temp_csv_upload_status: "0/36",
      tryagainCSVImport: false,
      loading: true,
      loadingCommand: false,
      success: false,
      tryagainWarning: false,
      tryagainWarning2: false,
      ctrlytics_ipad_err: false,
      ctrlytics_iphone_err: false,
      isEnterpriseAvailable: false,
      isFilled: false,
      device_available_to_add: true,
      add_device_window: false,
      remove_device_prompt: false,
      allow_register: true,
      currentRole: localStorage.role,
      temp_serial_number_add: "",
      temp_device_name_add: "",
      temp_device_status_add: "PENDING DEVICE",
      data: [],
      device_corp_data: [],
      corpRegister: {
        company_name: "",
        pic_name: "",
        pic_email: "",
        pic_contact: "",
      },
      id_info_collect: {
        preset_contact: process.env.VUE_APP_PRESET_CONTACT,
        preset_contact_hint: process.env.VUE_APP_PRESET_CONTACT_HINT,
        preset_reg_title: process.env.VUE_APP_PRESET_ID_REG_INFO,
        preset_reg_hint: process.env.VUE_APP_PRESET_ID_REG_MORE_INFO,
        preset_reg_err: process.env.VUE_APP_PRESET_ERROR_MESSAGE_VALIDATION
      },
      lang: {
        title: "",
        second_title: "",
        cancel_btn: "Cancel",
        company_selection: "",
        company_selection_hint: "",
        content: "",
        fullname: "",
        fullname_hint: "",
        serialnum: "",
        serialnum_hint: "",
        msisdn: "",
        msisdn_hint: "",
        devicemodel: "",
        devicemodel_hint: "",
        device_eligibility: false,
        email: "",
        email_hint: "",
        nric: "",
        nric_hint: "",
        imei1: "",
        imei1_hint: "",
        imei2: "",
        imei2_hint: "",
        selector_hint: "",
        contracttenure: "",
        contracttennue_hint: "",
        back_button: "",
        register_button: "",
        tryagain: "",
        notice_title: "",
        notice_text: "",
        notice_button1: "",
        notice_button2: "",
        invalid_csv: [],
        feature_unavailable_ipados: [],
        feature_unavailable_macos: [],
        csv_entry_popup: [],
        add_device_popup: [],
        remove_device_popup: [],
        load_csv_message: [],
        register_x_mark: "X",
        upload_batch_csv: "Upload CSV",
        add_device: "Add Device",
        remove_device: "Remove Device",
        register_api_error_msg: "",
      },
      productFamily: null,
    };
  },
  computed: {
    filtered_device_selection_list() {
      const q = (this.search_filtered_serial_number || '').toLowerCase();
      if (!q) return this.device_selection_list;
      return this.device_selection_list.filter(
        d => d[2] && d[2].toLowerCase().includes(q)
      );
    }
  },
  methods: {
    // Your actual function to call when typing stops
    tryGetSerialNumber() {
      this.devicemodel = "Getting device model...";
      this.isLoading = true;
      console.log('Making API call with:', this.serialnum);
      
      // Get serial_number data
      //Prep API
        const data = JSON.stringify({
            session_id: localStorage.token,
            serial_number: this.serialnum
        });
        const axios = require('axios');
        let config = {
            method: 'POST',
            maxBodyLength: Infinity,
            url: process.env.VUE_APP_BACKEND_URL+'/v1/dashboard/register/check-device',
            headers: {
              "Authorization": `Bearer ${localStorage.bearer_token}`,
              'Content-Type': 'application/json'
            },
            data: data
        };

        //Run API
        axios.request(config)
          .then((response) => {
              if (response.status === 200) {
                console.log(response.data[0].model);
                this.devicemodel = response.data[0].model;
                console.log(response.data[0].model);
              } else {
                this.devicemodel = "Device not detected in Apple Business Manager";
              }
              
          })
          .catch((error) => {
              console.log(error);
              this.page_unavailable = true;
              this.devicemodel = "Device not detected in Apple Business Manager";
          });

      setTimeout(() => {
        console.log('API call completed for:', this.serialnum);
        this.isLoading = false;
      }, 1000);
    },

    // Regular input handler
    handleInput() {
      this.debouncedTryHit();
    },
    register() {
      this.imei1 = "-1";
      this.imei2 = "-1";
      if (
        this.msisdn == "" &&
        this.serialnum == "" &&
        this.fullname == "" &&
        this.email == "" &&
        this.nric == "" &&
        this.contracttenure == ""
      ) {
        this.tryagainWarning = true;
      } else {
        this.loading = true;
        this.tryagainWarning = false;
        console.log("Registering");
        const axios = require("axios");

        let data = JSON.stringify({
          full_name: this.fullname,
          nric: this.nric,
          phone_no: this.msisdn,
          email: this.email,
          serial_number: this.serialnum.toUpperCase(),
          tenure: this.contracttenure,
          session_id: localStorage.token,
        });

        let config = {
          method: "post",
          maxBodyLength: Infinity,
          url:
            process.env.VUE_APP_BACKEND_URL +
            "/v1/dashboard/register/user",
          headers: {
            "Authorization": `Bearer ${localStorage.bearer_token}`,
            "Content-Type": "application/json", // Set Content-Type for JSON data
          },
          data: data,
        };

        axios
          .request(config)
          .then((response) => {
            console.log("Test response location non-error");
            console.log(response.status);
            console.log(JSON.stringify(response.data));
            if (response.status === 200) {
              this.success = true;
              this.isFilled = true;
            }
          })
          .catch((error) => {
            console.log("Test response location error");
            console.log(error);
            if (error.response.status === 403) {
              this.tryagainWarning2 = true;
              this.productFamily = error.response.data["product_family"];

              this.lang.register_api_error_msg = error.response.data["message"];
            } else {
              this.isFilled = true;
              this.tryagainWarning = true;
            }
          });
        //setTimeout(() => {
        //    this.success = true;
        //}, 3000);
      }
    },
    checkForMatchingSerials(csvSerials, existingSerials) {
      existingSerials = existingSerials.map(item => item.serial_number);
      for (const serial_number of csvSerials) {
        console.log(serial_number);
        console.log(existingSerials);
        if (existingSerials.includes(serial_number)) {
          return true;
        }
      }
      return false;
    },
    userRegistration() {
      this.loading = true;
      const data = JSON.stringify({
        session_id: localStorage.token
      });
      const axios = require("axios");
      let config = {
        method: "POST",
        maxBodyLength: Infinity,
        url: process.env.VUE_APP_BACKEND_URL + "/v1/dashboard/register/device-list",
        headers: {
          "Authorization": `Bearer ${localStorage.bearer_token}`,
          "Content-Type": "application/json",
        },
        data: data,
      };
      //Run API
      axios
        .request(config)
        .then((response) => {
          if (response.status === 200) {
            this.device_selection_list = response.data.result;
          } else {
            this.page_unavailable = true;
          }
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
          this.page_unavailable = true;
          this.loading = false;
        });
      },
    addPhoneCode() {
      if (!this.msisdn.startsWith(this.id_info_collect.preset_contact)) {
        this.msisdn = this.id_info_collect.preset_contact + this.msisdn;
      }
    },
    checkIfSerialNumberSelected() {
      console.log("Function pinged");
      console.log(this.allow_register);
      if (this.serialnum == "-Select device-") {
        this.allow_register = true;
      }
      this.allow_register = false;
      this.search_filtered_serial_number = this.serialnum;
    },  
    checkLogin() {
      //Enable overlay
      this.loading = true;
      //Prep API
      const data = JSON.stringify({
        token: localStorage.token,
      });
      const axios = require("axios");
      let config = {
        method: "POST",
        maxBodyLength: Infinity,
        url: process.env.VUE_APP_BACKEND_URL + "/v1/login/validity-check",
        headers: {
          "Authorization": `Bearer ${localStorage.bearer_token}`,
          "Content-Type": "application/json",
        },
        data: data,
      };
      //Run API
      axios
        .request(config)
        .then((response) => {
          if (response.status === 200) {
            this.loading = false;
          } else {
            this.page_unavailable = true;
            this.loading = false;
          }
        })
        .catch((error) => {
          console.log(error);
          this.page_unavailable = true;
          this.loading = false;
        });
    },
    goBack() {
      this.$router.replace("/dashboard"); // Go back one step in the history
    },
    goDashboard() {
      this.$router.replace("/dashboard");
    },
    backToRegister() {
      location.reload();
    },
    async langchange(picker) {
      console.log(picker);
      console.log(this.data);
      const response = await fetch("/register/registeruser.json");
      const data = await response.json();
      this.data = data;
      this.lang = this.data[picker];
      this.$refs.BottomFooterRef.langchange(picker);
    },
  },
  mounted() {
    this.checkLogin();
    // For periodic serial_number checking purposes
    this.debouncedTryHit = useDebounceFn(this.tryGetSerialNumber, 500);
    this.userRegistration();
  },
};
</script>

<style scoped>
*:disabled {
  background-color: dimgrey !important;
  color: linen;
  opacity: 1;
}

.layout {
  display: flex;
}

.regdevice_contents {
  flex: 1;
  padding-left: 16px;
  font-family: "Century Gothic";
}

.regdevice_header {
  font-family: "Century Gothic Bold";
  font-weight: bold;
  font-size: 24px;
  margin-top: 5px;
}

.regdevice_secondary_header {
  font-family: "Century Gothic Bold";
  font-weight: bold;
  font-size: 20px;
  margin-top: 15px;
}

.regdevice_secondary_container {
  margin-top: -12px;
}

.regdevice_container {
  display: flex;
  justify-content: center !important;
  align-items: center !important;
  flex-direction: column;
}

.customercat-container{
  display: flex;
  justify-content: center;
  align-items: center;
}

.categoryopt-text{
  font-size: 12px;
}

.contents_header_text {
  font-size: 14px;
  margin-top: -15px;
}

.img_style {
  width: 80px;
  height: 80px;
  margin-bottom: 10px;
}

.notiftext_title {
  font-family: "Century Gothic Bold";
  font-size: 12px;
  color: #000000;
  margin-bottom: 2px;
}

.notiftext {
  font-family: "Century Gothic";
  text-align: center !important;
  font-size: 12px;
  color: #000000;
  margin-bottom: 8px;
}

.input_header_style {
  font-family: "Century Gothic Bold";
  font-size: 12px;
  color: #013042;
  margin-bottom: 2px;
}

.reg_btn {
  text-align: center;
  margin-top: 20px;
  width: 140px;
  height: 30px;
  font-family: "Century Gothic Bold", sans-serif;
  font-size: 10px;
  border: none;
  border-radius: 28px;
  padding: 0.3vw;
  background-color: #ffd600;
  color: #013042;
  transition: background-color 0.3s ease;
  font-weight: 500;
}

.reg_btn:hover {
  filter: brightness(90%);
}

.x_button {
  text-align: center;
  width: 40px;
  height: 30px;
  font-family: "Century Gothic Bold", sans-serif;
  font-size: 10px;
  border: none;
  border-radius: 28px;
  padding: 0.3vw;
  background-color: #ff0000;
  color: #ffffff;
  transition: background-color 0.3s ease;
  font-weight: 500;
}

.x_button:hover {
  filter: brightness(90%);
}

.upload_btn {
  text-align: center;
  margin-top: 20px;
  width: 140px;
  height: 30px;
  font-family: "Century Gothic Bold", sans-serif;
  font-size: 10px;
  border: none;
  border-radius: 28px;
  padding: 0.3vw;
  background-color: #ffd600;
  color: #013042;
  transition: background-color 0.3s ease;
  font-weight: 500;
}

.upload_btn:hover {
  filter: brightness(90%);
}

.add_btn {
  text-align: center;
  margin-top: 20px;
  width: 140px;
  height: 30px;
  font-family: "Century Gothic Bold", sans-serif;
  font-size: 10px;
  border: none;
  border-radius: 28px;
  padding: 0.3vw;
  background-color: #ffd600;
  color: #013042;
  transition: background-color 0.3s ease;
  font-weight: 500;
}

.add_btn:hover {
  filter: brightness(90%);
}

.mandev_btn {
  text-align: center;
  width: 150px;
  height: 30px;
  margin-bottom: 5px;
  font-family: "Century Gothic Bold", sans-serif;
  font-size: 10px;
  border: none;
  border-radius: 28px;
  padding: 0.3vw;
  background-color: #ffd600;
  color: #013042;
  transition: background-color 0.3s ease;
  font-weight: 500;
}

.mandev_btn:hover {
  filter: brightness(90%);
}

.button_container {
  width: auto;
}
.cancel_btn {
  text-align: center;
  width: 150px;
  padding: 0.3vw;
  margin-left: 10px;
  font-family: "Century Gothic Bold", sans-serif;
  font-size: 10px;
  border-radius: 28px;
  background-color: #ff0000;
  border-color: #013042;
  color: #ffffff;
  transition: background-color 0.3s ease;
  font-weight: 500;
}

.cancel_btn {
  filter: brightness(90%);
}

.dashboard_btn {
  text-align: center;
  width: 150px;
  height: 30px;
  font-family: "Century Gothic Bold", sans-serif;
  font-size: 10px;
  border-radius: 28px;
  padding: 0.3vw;
  background-color: #ffffff;
  border-color: #013042;
  color: #013042;
  transition: background-color 0.3s ease;
  font-weight: 500;
}

.dashboard_btn:hover {
  filter: brightness(90%);
}

.custom_input_form {
  background-color: #ffffff;
  height: 35px;
  width: 400px;
  text-decoration: none solid rgba(0, 0, 0, 0.87);
  border-color: rgba(1, 48, 66, 0.2) !important;
  word-spacing: 0px;
  letter-spacing: 0.131118px;
  font-size: 12px !important;
  box-sizing: border-box;
  outline: rgba(0, 0, 0, 0.87) none 0px;
}

.custom_input_form:focus {
  outline: none !important;
  box-shadow: none !important;
  border-color: rgba(1, 48, 66, 0.8) !important;
  border-width: 2.5px;
  background-color: #ffffff;
  color: #000000;
  font-size: 12px;
}

.form-control:disabled {
  background-color: #adb5bd !important;
}

::placeholder {
  font-size: 12px;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  /* Semi-transparent overlay */
  z-index: 9998;
  /* Below the loading content */
}

.warning-msg {
  color: red;
  font-weight: bold;
  font-size: 12px;
  margin-top: 10px;
}

.loading-card {
  position: fixed;
  width: 500px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: white;
  padding: 20px;
  border-radius: 28px;
  filter: brightness(98%);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.loading-content {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.loading-text {
  justify-items: center;
  display: grid;
  font-family: "Century Gothic", sans-serif;
  text-align: center;
}

.img_style_denied_perms {
  width: 80px;
  height: 80px;
  margin-bottom: 10px;
  left: 10px;
}

.notiftext_title_denied_perms {
  font-family: "Century Gothic Bold";
  font-size: 16px;
  color: #000000;
  margin-bottom: 2px;
}

.notiftext_denied_perms {
  font-family: "Century Gothic";
  text-align: center !important;
  font-size: 12px;
  color: #000000;
  margin-bottom: 8px;
}

.categoryopt-label{
  font-family: "Century Gothic Bold";
  font-size: 14px;
  color: #013042;
  margin-bottom: 2px;
}

.options-selector {
  display: flex;
  width: 400px;
  font-size: 14px;
  left: auto;
  right: auto;
}

.options-selector:focus{
  outline: none !important;
  box-shadow: none !important;
  border-color: rgba(1, 48, 66, 0.8) !important;
  border-width: 2.5px;
  background-color: #ffffff;
  color: #000000;
  font-size: 14px;
}

.table_header {
  background-color: #cccccc;
  text-align: center;
  border-bottom: 1px solid #989898;
}

.table_body_border {
  border-bottom: 1px solid #989898;
}

.tablehead_text {
  font-family: "Century Gothic Bold", sans-serif;
  font-size: 14px;
  text-align: center;
}

.table_container {
  flex-basis: 100%;
  margin-top: 25px;
  max-width: 650px;
  overflow-y: auto;
  max-height: 32vh;
}

.table_container::-webkit-scrollbar {
  width: 8px;
}

.table_container::-webkit-scrollbar-thumb {
  background-color: #888;
  border-radius: 4px;
}

.table_container::-webkit-scrollbar-track {
  background-color: #eee;
  border-radius: 4px;
}

.table_styles {
  width: 100%;
}

thead tr {
  height: 50px;
}

th,
td {
  text-align: center;
  padding: 16px;
}

.odd_row {
  background-color: #ffffff;
}

.even_row {
  background-color: #e6e6e6;
}

.table_header {
  background-color: #cccccc;
  text-align: center;
  border-bottom: 1px solid #989898;
}

.table_body_border {
  border-bottom: 1px solid #989898;
}

.tablehead_text {
  font-family: "Century Gothic Bold", sans-serif;
  font-size: 14px;
  text-align: center;
}

@media (max-width: 376px) {
  .custom_input_form {
    width: 280px;
  }

  .regdevice_secondary_container {
    margin-top: -10px;
  }
}
</style>
